// extracted by mini-css-extract-plugin
module.exports = {"floatingButton":"FloatingButton_floatingButton___6Hf7","backButton":"FloatingButton_backButton__Fbj5F"};